import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuoteLeft,
  faHeartPulse,
  faStethoscope,
  faHandsHoldingChild,
  faGraduationCap,
  faAward,
  faCheckCircle,
  faWarning,
  faBuildingCircleCheck
} from "@fortawesome/free-solid-svg-icons";
import NavbarLogo from "../components/Navbar/csdv2Logo.png";
import FounderImg from "../assets/about/1.jpeg";
import ArticalImg1 from "../assets/articals/WhatsApp Image 2026-03-25 at 6.50.44 PM.jpeg";
import ArticalImg2 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM.jpeg";
import ArticalImg3 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM (1).jpeg";
import ArticalImg4 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM (2).jpeg";
import ArticalImg5 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.52 PM.jpeg";
import ArticalImg6 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.52 PM (1).jpeg";


const OBJS = [
  "To provide affordable, accessible healthcare to children with Congenital Heart Disease.",
  "To organize medical outreach camps, diagnostic drives, and referral services.",
  "To educate the public on prevention, early detection, and treatment of CHD.",
  "To train doctors, nurses, and community workers in paediatric cardiac care.",
  "To collaborate with the government, hospitals, and NGOs for the delivery of paediatric healthcare.",
  "To raise funds via donations, grants, CSR contributions, and other lawful sources."
];

const CHALLENGES = [
  { title: "Delayed Diagnosis", items: ["Late detection in rural areas", "Limited fetal echo & pediatric cardiologists"] },
  { title: "Infrastructure Gaps", items: ["Limited Cath labs in public hospitals", "Shortage of pediatric surgeons"] },
  { title: "Cost & Accessibility", items: ["High burden of surgeries", "Non-uniform implementation of schemes"] },
  { title: "Device Availability", items: ["High cost of imported occluder devices"] }
];

const Aboutus = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section */}
      <section className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-white" />
        <div className="container mx-auto px-6 relative z-10 text-center">
          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter flex flex-col md:flex-row items-center justify-center gap-6">
            <img src={NavbarLogo} alt="Logo" className="hidden md:block md:h-32 w-auto" />
            <span>Our <span className="italic opacity-80">Story</span></span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light opacity-90 leading-relaxed">
            Driven by history, guided by faith, and committed to mending every little heart in need.
          </p>
        </div>
      </section>

      {/* Founder Profile - Details Container (Moved to First Position) */}
      <section className="py-24 bg-brand-beige/20 border-y border-brand-red/5">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-16 items-start">
            {/* Image Container */}
            <div className="md:w-1/3 pt-4">
              <div className="relative group mx-auto w-full max-w-[320px]">
                <div className="absolute -inset-2 bg-brand-red/5 rounded-3xl blur-xl" />
                <div className="relative overflow-hidden rounded-[2.5rem] shadow-2xl border-4 border-white">
                  <img
                    src={FounderImg}
                    alt="Dr Ashok Raju Alluri"
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Details Container */}
            <div className="md:w-2/3 space-y-6">
              <div>
                <span className="text-brand-red text-sm font-black tracking-widest uppercase mb-3 block">
                  Founder & Managing Trustee
                </span>
                <h2 className="text-4xl md:text-5xl font-black tracking-tighter mb-4 text-slate-900">
                  Dr. Alluri Ashok Raju
                </h2>
                <p className="text-xl md:text-2xl font-bold text-slate-700 leading-tight mb-2">
                  MD (Paed.), DM (Cardiology - Gold Medalist), PDF (Paed. Card.), MBA (HA), Fetal Echocardiography (Mediscans)
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {[
                    "Pediatric Specialist",
                    "Interventional Cardiology",
                    "Fetal Echocardiography",
                    "Healthcare Management"
                  ].map((skill, index) => (
                    <span key={index} className="px-4 py-2 bg-white text-slate-700 rounded-xl text-sm font-bold shadow-sm border border-slate-100">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className="space-y-4 text-lg text-slate-600 leading-relaxed">
                <p>
                  Strongly positioned as an expert and a pioneer in the field, Dr. Ashok Raju is striving to improve the state of pediatric interventional cardiology in the coastal Andhra Pradesh region. He is today the only DM pediatric interventional cardiologist in the 1000km long coastal Andhra Pradesh.
                </p>
                <p>
                  Having completed his MD in Pediatrics from Kasturba Medical College, Dr. Ashok pursued his DM in Cardiology (Gold medalist) from NTR University. Driven by passion, he got selected for the Post-Doctoral Fellowship in Pediatric Cardiology at the Madras Medical Mission under the globally renowned Dr. Kothandam Siva Kumar.
                </p>
                <div className="p-6 bg-brand-red/5 border-l-4 border-brand-red rounded-r-2xl italic font-medium text-slate-700">
                  "Healing hearts, empowering lives. My journey has been driven by one goal: ensuring no child suffers from untreated heart defects."
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ushering New Lives (Introduction/Burden) */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto space-y-12">
            <h2 className="text-4xl font-black tracking-tighter text-center">
              Ushering New Lives to <span className="text-brand-red">CHD-affected Kids & Parents</span>
            </h2>
            <div className="grid md:grid-cols-2 gap-12 text-slate-600 text-lg leading-relaxed">
              <div>
                <p className="mb-6">
                  Currently seeing around 25 million child births annually, the prevalence of congenital heart diseases (CHD) has increased drastically in recent years in India. As per a research paper published in the European Journal of Cardiovascular Medicine, the birth prevalence of severe CHD currently stands at 1.5–1.7 per 1000 live births and approximately 10 percent of infant mortality can be attributed to CHD lately. 
                </p>
                <p>
                  Although India has witnessed many tech advancements, pediatric cardiology as a specialist medical field is still in its nascence across many parts of the country today.
                </p>
              </div>
              <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
                <h3 className="text-xl font-bold text-slate-900 mb-4">A Legacy of Emotional Pain & Passion</h3>
                <p>
                  Hailing from a lower middle-class family, Dr. Ashok witnessed firsthand the deep grief a family undergoes due to CHD when three of his own siblings died early on in their lives. His elder sister couldn’t survive beyond the age of 26 years. Recognizing the severe dearth of pediatric cardiology services, he took-up specialization to bridge this critical gap.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Pediatric Cardiologist / Contributions */}
      <section className="py-24 bg-slate-900 text-white relative">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="mb-16 text-center">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tighter text-brand-red">
                Expertise & Milestones
              </h2>
              <p className="text-xl text-slate-400 max-w-3xl mx-auto">
                Devoting life towards improving interventional pediatric cardiology services.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-16">
              <div className="glass-dark p-8 rounded-3xl border-white/5 text-center">
                <div className="text-5xl font-black text-brand-gold mb-4">3,000+</div>
                <div className="text-sm font-bold uppercase tracking-widest text-slate-300">Children Screened Free of Cost</div>
              </div>
              <div className="glass-dark p-8 rounded-3xl border-white/5 text-center">
                <div className="text-5xl font-black text-brand-gold mb-4">500+</div>
                <div className="text-sm font-bold uppercase tracking-widest text-slate-300">Successful Cardiac Interventions</div>
              </div>
              <div className="glass-dark p-8 rounded-3xl border-white/5 text-center">
                <div className="text-5xl font-black text-brand-gold mb-4">99%</div>
                <div className="text-sm font-bold uppercase tracking-widest text-slate-300">Success Rate</div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-16">
              <div className="space-y-6 text-lg text-slate-300 leading-relaxed">
                <h3 className="text-2xl font-bold text-white">Pioneering Interventions</h3>
                <p>
                  Dr. Ashok has done numerous innovative pediatric cardiac catheter interventions globally acclaimed like large 50mm ASD device closure, balloon assisted PDA device closure, and trans catheter closure of giant coronary cameral fistulae. These procedures, earlier unavailable in coastal Andhra Pradesh, are now offered even free of cost through numerous government schemes.
                </p>
                <p>
                  He has presented his innovative interventions at prestigious international & national conferences such as CSI Frankfurt (Germany), CSI Asia Pacific (Bangkok), CSI Vietnam, Indialive (India) and PCSI (India).
                </p>
              </div>
              <div className="glass-dark p-8 rounded-3xl border-brand-red border relative">
                <FontAwesomeIcon icon={faQuoteLeft} className="text-brand-red text-4xl mb-4" />
                <h3 className="text-xl font-bold text-white mb-4">A Memorable Success Story</h3>
                <p className="text-slate-300 italic mb-6">
                  "A baby weighing just 2kg with a serious condition called pulmonary atresia with PDA-dependent circulation was once brought to me. Despite the baby being on the verge of crashing, we immediately performed a successful PDA stenting. Once it turned six months, we performed a pulmonary wall perforation leading to speedy recovery. The child is living a perfectly normal and healthy life now."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contributing to Society */}
      <section className="py-24 bg-brand-red/5">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-1/2">
              <h2 className="text-3xl md:text-4xl font-black mb-6 tracking-tighter uppercase">
                Contributing towards a <span className="text-brand-red">Better Society</span>
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed mb-6">
                Keeping in mind that 90-95 percent of the children with CHD lack proper monetary support, we aspire to create awareness among corporates about pediatric cardiology and persuade them to contribute a portion of their CSR budget towards helping children get the necessary treatment.
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                Dr Ashok started <strong>‘Shishu Hriday charitable trust’</strong> to bridge the gap primarily targeting children in urgent need of heart surgery from low-income families and provide them with the necessary medical, financial and post-operative support.
              </p>
            </div>
            <div className="md:w-1/2">
              <div className="bg-white p-10 rounded-3xl shadow-xl border border-brand-red/10 relative">
                <FontAwesomeIcon icon={faQuoteLeft} className="text-brand-red/20 text-6xl absolute top-6 left-6" />
                <p className="text-xl text-slate-800 font-medium italic relative z-10 leading-relaxed">
                  "While over 10,000 children are born in Andhra Pradesh every year with CHD, only around 1200 children are able to avail treatment and the remaining are seeing the end of life due to lack of awareness and monetary resources... We are mainly trying to somehow balance the monetary aspect and improve awareness so that more children can be saved if treated early."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sharing Words of Wisdom */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-black text-slate-900 mb-12 tracking-tighter">
              Sharing <span className="text-brand-red">Words of Wisdom</span>
            </h2>
            <div className="grid md:grid-cols-2 gap-8 text-left mb-16">
              <div className="bg-brand-beige/30 p-8 rounded-3xl">
                <h3 className="font-black text-xl mb-4 text-slate-900">Prevention & Awareness</h3>
                <ul className="space-y-4 text-slate-700 font-medium">
                  <li className="flex items-start gap-3">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-brand-red mt-1" />
                    <span>The right time to get married is 25-30 years. Women should get pregnant before they turn 28 years to reduce chances of CHD.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-brand-red mt-1" />
                    <span>Both parents must be completely free of smoking, alcohol, and drugs.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <FontAwesomeIcon icon={faWarning} className="text-brand-gold mt-1" />
                    <span>Risk of a child developing CHD is high in consanguineous marriages.</span>
                  </li>
                </ul>
              </div>
              <div className="bg-brand-red/10 p-8 rounded-3xl">
                <h3 className="font-black text-xl mb-4 text-slate-900">Early Detection</h3>
                <p className="text-slate-700 font-medium leading-relaxed mb-4">
                  Most importantly, parents must get their fetal ECHO scan done soon after they conceive.
                </p>
                <div className="bg-white p-4 rounded-xl border border-brand-red/20 shadow-sm text-slate-600 italic">
                  Early fetal ECHO can identify CHD in the womb itself and help the parents to accordingly plan their next course of action.
                </div>
              </div>
            </div>

            <div className="text-2xl md:text-3xl font-black text-slate-800 leading-tight italic max-w-3xl mx-auto">
              “Unlike earlier when pediatric cardiology could only be cured through surgery and had a mortality rate of 30-40 children in 100, <span className="text-brand-red">70-80 percent of the pediatric CHDs can now be easily managed</span> through pediatric cardiology interventions with a 99 percent success rate.”
            </div>
          </div>
        </div>
      </section>

      {/* Trust Objectives */}
      <section className="py-24 bg-slate-900 text-white relative">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-16 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tighter">Trust <span className="text-brand-red">Objectives</span></h2>
              <p className="text-slate-400 text-lg mb-8 leading-relaxed">
                Founded with a clear roadmap, the Shishu Hriday Charitable Trust operates under strict objectives to ensure systemic change in pediatric care.
              </p>
              <div className="w-20 h-2 bg-brand-red rounded-full mb-12" />
            </div>
            <div className="lg:w-1/2 grid grid-cols-1 gap-6">
              {OBJS.map((obj, i) => (
                <div key={i} className="glass-dark p-6 rounded-2xl border-white/5 flex gap-4 items-start group hover:border-brand-red/50 transition-colors">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-brand-red mt-1 group-hover:scale-110 transition-transform" />
                  <p className="text-slate-300 font-medium">{obj}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Articals */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 tracking-tight uppercase">
            In The <span className="text-brand-red">News</span>
          </h2>
          <div className="max-w-6xl mx-auto px-4 md:px-12">
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={3}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={3000}
              pauseOnHover={true}
              responsive={[
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
              ]}
              className="articles-slider"
            >
              {[ArticalImg1, ArticalImg2, ArticalImg3, ArticalImg4, ArticalImg5, ArticalImg6].map((img, index) => (
                <div key={index} className="px-3 py-4">
                  <div
                    className="rounded-2xl overflow-hidden shadow-lg border-4 border-slate-100 h-96 bg-white relative group cursor-pointer transform hover:-translate-y-2 transition-all duration-300"
                    onClick={() => window.open(img, '_blank')}
                  >
                    <img
                      src={img}
                      alt={`News Article ${index + 1}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-brand-red/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-[2px]">
                      <span className="bg-white text-brand-red px-6 py-3 rounded-full font-black text-sm shadow-2xl tracking-wide uppercase">
                        View Article
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-32 bg-slate-50 border-t border-slate-100 text-center">
        <div className="container mx-auto px-6">
          <div className="w-24 h-24 gradient-bg rounded-3xl flex items-center justify-center text-white mx-auto shadow-2xl mb-12">
            <FontAwesomeIcon icon={faHeartPulse} size="3x" className="animate-pulse" />
          </div>
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter mb-8 max-w-3xl mx-auto leading-tight">
            Every child deserves <span className="gradient-text">a healthy heart.</span>
          </h2>
          <Link to="/donate-now" className="inline-block px-12 py-5 gradient-bg text-white rounded-full font-black text-xl hover-glow transform hover:scale-105 transition-all shadow-2xl uppercase tracking-tighter">
            Join Our Mission
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Aboutus;